import { store } from '../stores/mainStore';

export function preload() {
	const m = window.manager;
	let scene = this;
	let showSize = false;
	store.phaserLoading = !m.sceneRestarting;
	console.log('phaser loading', store.phaserLoading);

	this.load.once('complete', function () {
		console.log('phaser load complete');
		store.phaserLoading = false;
		if (store.tutorialMode) {
			store.tutorialState = 'avaOpponent';
		}
	});

	this.load.on('progress', v => {
		store.phaserLoadPercentage = Math.floor(v * 100);
	});

	this.load.on('loaderror', function (fileObj) {
		console.log('phaser loadERROR ' + fileObj);
	});

	if(m.sceneRestarting !== true) {
		this.load.audioSprite('sfx', m.assetURL + '/sounds/audio_web.json', [
			m.assetURL + '/sounds/audio_web.ogg',
			m.assetURL + '/sounds/audio_web.mp3',
			m.assetURL + '/sounds/audio_web.m4a'
		]);
	}

	const loadMultiAtlas = (keyName, jsonPath, assetPath) => {
		if(!this.textures.exists(keyName)) {
			console.log("LOADING MULTIATLAS: "+keyName);
			this.load.multiatlas(keyName, jsonPath, assetPath);
		}
	}
	const loadSpriteSheet = (keyName, asset, obj, sideLoad=false) => {
		if(!this.textures.exists(keyName)) {
			if(sideLoad) {
				store.phaserSideLoadSpriteSheets.push({keyName: keyName, asset: asset, obj: obj});
			} else {
				if(showSize) {
					get_filesize(asset, function(size) {
						console.log('LOADING SPRITESHEET: '+asset+'\t\t SIZE: '+size);
						scene.load.spritesheet(keyName, asset, obj);
					});
				} else {
					console.log("LOADING SPRITESHEET: "+keyName);
					scene.load.spritesheet(keyName, asset, obj);
				}
			}
		}
	}
	const loadImage = (keyName, asset, sideLoad=false) => {
		if(!this.textures.exists(keyName)) {
			if(sideLoad) {
				store.phaserSideLoadImages.push({keyName: keyName, asset: asset});
			} else {
				if(showSize) {
					get_filesize(asset, function(size) {
						console.log('LOADING IMAGE: '+asset+'\t\t SIZE: '+size);
						scene.load.image(keyName, asset);
					});
				} else {
					console.log("LOADING IMAGE: "+asset);
					scene.load.image(keyName, asset);
				}
			}
		}
	}
	function get_filesize(url, callback) {
		var xhr = new XMLHttpRequest();
		xhr.open("HEAD", url, true); // Notice "HEAD" instead of "GET",
									 //  to get only the header
		xhr.onreadystatechange = function() {
			if (this.readyState === this.DONE) {
				callback(parseInt(xhr.getResponseHeader("Content-Length")));
			}
		};
		xhr.send();
	}
	
	let lang = store.validLanguage;

	loadMultiAtlas('common', m.assetURL + '/sprite_sheets/common-phaser.json', m.assetURL + '/sprite_sheets');

	// skins instead of customAssets or Themes
	const skinPath = m.assetURL + '/skin/';
	loadSpriteSheet('cup_sheet', skinPath + 'cup_sheet.png', {frameWidth: 180, frameHeight: 185});
	loadSpriteSheet('dice3D_sheet', skinPath + 'dice3D_sheet.png', {frameWidth: 128, frameHeight: 128});
	loadMultiAtlas('dice2D_sheet', skinPath + 'dice2D_sheet.json', skinPath);
	loadMultiAtlas('dice2D_sheet_64', skinPath + 'dice2D_sheet_64.json', skinPath);
	loadSpriteSheet('suits', skinPath + 'suits.png', {frameWidth: 54, frameHeight: 57});
	loadImage('gameBkg', skinPath + 'gameBkg.jpg');
	loadImage('bonusGameBkg', skinPath + 'bonusGameBkg.jpg');
	loadImage('watermark', skinPath + 'watermark.png');
	loadImage('playfieldFrame', skinPath + 'playfieldFrame.png');
	loadImage('bonusFieldFrame', skinPath + 'bonus_playfieldFrame.png');
	loadImage('score_bkg', m.assetURL + '/game/score_bg.png');


	loadSpriteSheet('logo_dice_sheet', m.assetURL + '/game/logo_grid_4.png', {frameWidth: 223, frameHeight: 225});
	loadSpriteSheet('dice_explosion', m.assetURL + '/sprite_sheets/diceExplosion.png', {frameWidth: 250, frameHeight: 225});
	loadSpriteSheet('flair', m.assetURL + '/sprite_sheets/dice_select_highlight/' + lang + '.png?v=1', {
		frameWidth: 338,
		frameHeight: 336,
	});

	loadMultiAtlas('poofNoCloud', m.assetURL + '/sprite_sheets/poofNoCloud.json', m.assetURL + '/sprite_sheets');
	loadMultiAtlas('swirl', m.assetURL + '/sprite_sheets/swirl.json', m.assetURL + '/sprite_sheets');
	loadSpriteSheet('hand', m.assetURL + '/hand_sheet.png', {
		frameWidth: 178,
		frameHeight: 181,
	});
	loadImage('border', m.assetURL + '/game/bumper320thick.jpg'); //left out of sprite sheet.
	loadImage('dimPanel', m.assetURL + '/game/dimPanel.png');
	loadImage('popper_button', m.assetURL + '/game/play_on_no_text.png');
	loadImage('popper_bonus', skinPath + 'btn_pop_bonus.png');
	loadImage('popper_button_grey', m.assetURL + '/game/play_off_no_text.png');
	loadImage('betDown', m.assetURL + '/game/btn_bet_down.png');
	loadImage('betUp', m.assetURL + '/game/btn_bet_up.png');
	loadImage('betMax', m.assetURL + '/game/btn_bet_max.png');
	loadImage('betBkg', m.assetURL + '/game/icon_bet_amount.png');
	loadImage('helpBtn', m.assetURL + '/buttons/btn_help.png');
	loadImage('coin', m.assetURL + '/coin_front.png');
	loadImage('chest', m.assetURL + '/dailyBonusChestCropped.png');
	loadImage('btn_close', m.assetURL + '/buttons/btn_close.png');
	loadImage('tutorial_box', m.assetURL + '/game/tutorial_boxes.png');

	m.sceneNeedsToReload = false;
}
